/* eslint-disable @typescript-eslint/no-explicit-any */
export const getPaginatedListData = (list: any[], page: number, itemsPerPage: number): any[] => {
	const startIndex = (page - 1) * itemsPerPage;
	return list.slice(startIndex, startIndex + itemsPerPage);
};

export const getCurrentPageSizeAsNumber = (currentPageSize: number | string, list: any[]): number => {
	return Number.isNaN(currentPageSize) ? list.length : Number(currentPageSize);
};
